import utils from 'helpers/utils';
import {
    FETCH_MEMBERSHIP_SCHEDULES,
    FETCH_MEMBERSHIP_SCHEDULES_FAILURE,
    FETCH_MEMBERSHIP_SCHEDULES_SUCCESS,
    FETCH_MEMBERSHIP_SCHEDULE,
    FETCH_MEMBERSHIP_SCHEDULE_FAILURE,
    FETCH_MEMBERSHIP_SCHEDULE_SUCCESS,
} from 'store/actions/types';

export const fetchMembershipSchedules = (payload) => {
    payload = payload || {};

    let params = {
        size: payload.size ? payload.size : 24,
        sort_by: payload.field ? payload.field : 'name',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'desc',
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    return {
        type: FETCH_MEMBERSHIP_SCHEDULES,
        payload: params,
    };
};

export const fetchMembershipSchedulesFailure = (error) => {
    return {
        type: FETCH_MEMBERSHIP_SCHEDULES_FAILURE,
        error: error,
    };
};

export const fetchMembershipSchedulesSuccess = (response) => {
    return {
        type: FETCH_MEMBERSHIP_SCHEDULES_SUCCESS,
        response: response,
    };
};

export const fetchMembershipSchedule = (payload) => {
    return {
        type: FETCH_MEMBERSHIP_SCHEDULE,
        payload: payload,
    };
};

export const fetchMembershipScheduleFailure = (error) => {
    return {
        type: FETCH_MEMBERSHIP_SCHEDULE_FAILURE,
        error: error,
    };
};

export const fetchMembershipScheduleSuccess = (response) => {
    return {
        type: FETCH_MEMBERSHIP_SCHEDULE_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/membership-schedules/fetchMembershipSchedules.js